import {
  GetConsultantEventLogEvents,
  useGetSwitchesDataQuery,
  useUpdateWelcomeEmailMutation
} from "@bonliva-crm/graphql";
import locale from "@bonliva-crm/locale";
import { useSnackbars } from "@hooks";
import { Box, Switch, Typography, makeStyles } from "@material-ui/core";

type Props = {
  consultantId: string;
};

export function WelcomeEmailSwitch(props: Props) {
  const { showError } = useSnackbars();

  const { data } = useGetSwitchesDataQuery({
    variables: { id: props.consultantId },
    fetchPolicy: "cache-first"
  });

  const [welcomeEmailMutation] = useUpdateWelcomeEmailMutation({
    onError: (error) => {
      showError(locale.cannotPerformAction);
      console.error(error);
    }
  });

  const setWelcomeEmail = (enabled: boolean) => {
    welcomeEmailMutation({
      variables: {
        id: props.consultantId,
        value: enabled
      },
      optimisticResponse: (vars) => {
        return {
          setConsultantWelcomeEmailSent: {
            ...data.consultantById,
            welcomeEmail: vars.value
          }
        };
      },
      refetchQueries: [GetConsultantEventLogEvents.OperationName]
    });
  };

  const { root } = useStyles();
  return (
    <Box className={root}>
      <Switch
        checked={data?.consultantById.welcomeEmail ?? false}
        onChange={(_, value) => setWelcomeEmail(value)}
      />
      <Typography variant="body1" style={{ paddingTop: "2px" }}>
        {locale.welcomeEmailSent}
      </Typography>
    </Box>
  );
}

const useStyles = makeStyles({
  root: {
    display: "flex",
    gap: "1rem",
    alignItems: "start"
  }
});
